import React from 'react';

import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { trackPageView } from './util/analytics';

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return null;
};

export default GoogleAnalytics;
